import { emit } from "../core/events";
import type { CspViolationDetail } from "../types";

let installed = false;

export function installCspViolationListener() {
  if (installed) return;
  installed = true;
  try {
    const handler = (e: Event) => {
      const v = e as SecurityPolicyViolationEvent;
      const stripUrl = (u: string | undefined | null) => {
        if (!u) return "";
        try {
          const url = new URL(u, location.href);
          // redact sensitive schemes
          if (url.protocol === "data:" || url.protocol === "blob:")
            return `${url.protocol}[redacted]`;
          url.search = "";
          url.hash = "";
          return url.toString();
        } catch {
          // best-effort strip query/hash if not a valid absolute URL
          return String(u).split("?")[0].split("#")[0];
        }
      };
      const truncate = (s: string | undefined, max = 200) =>
        typeof s === "string" ? (s.length > max ? s.slice(0, max) + "…" : s) : undefined;
      const toOrigin = (u: string | undefined) => {
        if (!u) return undefined;
        try {
          return new URL(u, location.href).origin;
        } catch {
          return undefined;
        }
      };
      const data: CspViolationDetail = {
        documentURI: stripUrl(v.documentURI || location.href),
        blockedURI: stripUrl(v.blockedURI || ""),
        effectiveDirective: v.effectiveDirective || "",
        violatedDirective: (v as any).violatedDirective,
        originalPolicy: truncate(v.originalPolicy, 500),
        sourceFile: stripUrl(v.sourceFile || undefined),
        statusCode: typeof v.statusCode === "number" ? v.statusCode : undefined,
        lineNumber: typeof v.lineNumber === "number" ? v.lineNumber : undefined,
        columnNumber: typeof v.columnNumber === "number" ? v.columnNumber : undefined,
        sample: truncate((v as any).sample, 200),
        disposition: (v as any).disposition,
        referrer: toOrigin((v as any).referrer),
        ts: Date.now(),
      };
      emit({ type: "csp.violation", data });
    };
    document.addEventListener("securitypolicyviolation", handler as EventListener);
    addEventListener("securitypolicyviolation", handler as EventListener, true);
  } catch {}
}
